import cupcake1 from "../../images/cupcake-2.jpg";
import cupcake2 from "../../images/cupcake-3.jpg";
import cupcake3 from "../../images/cupcake-4.jpg";
import cupcake4 from "../../images/cupcake-5.jpg";

export const productDataTwo = [
  {
    img: cupcake1,
    alt: "CupCake",
    name: "Supreme CupCake",
    desc: "Lovely cupcake that brings delight",
    price: "$19.99",
    button: "Add to Cart",
  },
  {
    img: cupcake2,
    alt: "CupCake",
    name: "Paradise CupCake",
    desc: "CupCake that makes you feel like you are in paradise",
    price: "$16.99",
    button: "Add to Cart",
  },
  {
    img: cupcake3,
    alt: "CupCake",
    name: "Oh See CupCake",
    desc: "Highly captivating, and delightfully tasty",
    price: "$14.99",
    button: "Add to Cart",
  },
  {
    img: cupcake4,
    alt: "CupCake",
    name: "Wowza CupCake",
    desc: "Healthy, and sweet-tasting cake",
    price: "$14.99",
    button: "Add to Cart",
  },
];
